import { AfterViewChecked, AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { WhiskeyItem } from '../../menu.model'

@Component({
  selector: 'american',
  templateUrl: './american.component.html',
  styleUrls: ['./american.component.scss']
})
export class AmericanComponent implements AfterViewInit {

  constructor() { }

  @Input() whiskeyList: Array<WhiskeyItem> = [];
  @Input() activeSection: string | undefined;

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}
